import React, { useState } from 'react';

const AnimatedImage = ({ src, alt, className = '', style = {} }) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  return (
    <div style={{ position: 'relative', ...style }}>
      {!loaded && !error && (
        <div className="image-skeleton" style={{ ...style }} />
      )}
      <img
        src={src}
        alt={alt}
        className={`${className} ${loaded ? 'image-loaded' : 'image-loading'}`}
        onLoad={() => setLoaded(true)}
        onError={() => setError(true)}
        style={style}
        loading="lazy"
      />
    </div>
  );
};

export default AnimatedImage;